import React, {PropsWithChildren, useEffect} from 'react';
import {
    PriorityIcon,
    Icon,
    InputProperties,
    Input,
    DropdownContextProps,
    Flex
} from '@priority-software/priority-style-react';
import {setInputLanguage, getLanguage} from '../../../../_shared/GWTBridge/invoke/common';
import {handleSpreadSheetPaste, spreadSheetProps} from '../../../../utils/paste';
import {createDataTestId} from '../../../../utils/dataTestId';

export interface SearchInputProps extends Partial<InputProperties & DropdownContextProps> {
    icon?: PriorityIcon | JSX.Element;
    // TODO: remove this property from SearchInput after SearchDropdown refactor
    closeOnClear?: boolean;
    displayClear?: boolean;
    handleSpreadsheetValues?: (parsedSpreadSheet: spreadSheetProps) => void;
    onReset?: () => void;
    direction?: 'rtl' | 'ltr' | 'auto';
}

export const SearchInput = (props: PropsWithChildren<SearchInputProps>) => {
    const {direction} = props;

    useEffect(() => {
        const len = getLanguage();
        if (len === 1) {
            if (direction === 'rtl') {
                setInputLanguage('he');
            } else if (direction === 'ltr') {
                setInputLanguage('en');
            }
        }
    }, [direction]);

    const handleChange = event => {
        const {value} = event.target;
        const {onChange, dropdownContext} = props;
        if (dropdownContext && !dropdownContext.open) {
            dropdownContext.openDropdown(value);
        } else {
            onChange(value);
        }
    };

    const handlePaste = event => {
        return handleSpreadSheetPaste(event, handleChange, props.handleSpreadsheetValues);
    };

    const handleClear = e => {
        e.stopPropagation();
        const {onChange} = props;
        onChange('');
    };

    const {
        icon,
        closeOnClear = false,
        displayClear = true,
        value = '',
        children,
        dataTestId,
        ...inputProps
    } = props;
    const iconElement = typeof icon === 'string' ? <Icon icon={icon} /> : icon;
    const isDisplayClear = value !== '' && displayClear;

    return (
        <Input
            direction={direction || 'auto'}
            value={value}
            {...inputProps}
            onChange={handleChange}
            onPaste={handlePaste}
            inlinePadding={!!children ? 'start' : 'all'}
            {...createDataTestId(dataTestId, true)}
        >
            <Flex inline>
                {isDisplayClear && (
                    <Icon icon={PriorityIcon.closeSmall} onClick={handleClear} skin="standart" />
                )}
                {(!isDisplayClear || !closeOnClear) && (
                    <>
                        {iconElement}
                        {children}
                    </>
                )}
            </Flex>
        </Input>
    );
};
